import isNil from "lodash/isNil";
import { useQuery } from "urql";

import { GetRiskReviewDocument } from "../../../graphql/generated.ts";

interface Props {
  id: number | string | null | undefined;
}

export const useRiskReview = ({ id }: Props) => {
  return useQuery({
    query: GetRiskReviewDocument,
    variables: { id: Number(id) },
    pause: isNil(id),
  });
};
